var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg037FolderNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 22H21C21.5523 22 22 21.5523 22 21C22 20.4477 21.5523 20 21 20H13V18H20C20.5523 18 21 17.5523 21 17V4.00003C21 3.44775 20.5523 3.00003 20 3.00003H14C13.7342 2.9985 13.4787 3.10285 13.29 3.29003L11.59 5.00003H4C3.44772 5.00003 3 5.44775 3 6.00003V17C3 17.5523 3.44772 18 4 18H11V20H3C2.44772 20 2 20.4477 2 21C2 21.5523 2.44772 22 3 22ZM5 16V7.00003H12C12.2658 7.00157 12.5213 6.89722 12.71 6.71003L14.41 5.00003H19V16H5Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg037FolderNetwork);
export default __webpack_public_path__ + "static/media/037-folder-network.a872cf50faba6681f26133419b88341b.svg";
export { ForwardRef as ReactComponent };